export const ISSUES_ROUTE_NAMES = {
    LIST: "IssuesPage",
};
